import {Localized} from "@fluent/react";
import React from "react";

import type ContentIssueType from "../../store/courses/ContentIssueType";
import ChipsSelector from "../../utils/ChipsSelector";

const issueTypes: ContentIssueType[] = ["mistake", "obscure", "technical"];

function ContentIssueTypeFilter(props: {
	value: ContentIssueType[];
	onChange: (val: ContentIssueType[]) => void;
}) {
	return (
		<ChipsSelector
			options={issueTypes}
			value={props.value}
			onChange={props.onChange}
			getOptionLabel={(opt) => (
				<Localized id="content-issues-widget-issue-type" vars={{type: opt}}>
					{opt}
				</Localized>
			)}
		/>
	);
}

export default ContentIssueTypeFilter;
